import routes from './routes';
import { IModuleProps } from '../core/utils/modules';

export default {
    name: 'analytics',
    routes,
} as IModuleProps;
